function pages() {
  return [
    { id: 1, name: 'electricity', favorite_questions: [], new_questions: [] },
    { id: 2, name: 'gas', favorite_questions: [] },
    { id: 3, name: 'fuel', favorite_questions: [] },
    { id: 4, name: 'diesel', favorite_questions: [] },
    { id: 5, name: 'water consumption', favorite_questions: [] },
  ];
}

export default {
  pages,
};
